export default __webpack_public_path__ + "static/media/Believer's Jerkin of the Exalted Spirit.8070d20b.jpg";